const Reflux = require('@muzzylane/reflux');

const GoogleClassroomActions = Reflux.createActions({
    setGapiState: { children: ["completed"] },
    setSignInClickedState: { children: ["completed"] },
});

GoogleClassroomActions.setGapiState.listen(function(state) {
    this.completed(state);
});

GoogleClassroomActions.setSignInClickedState.listen(function(state) {
    this.completed(state);
});

module.exports = GoogleClassroomActions;